import { render, staticRenderFns } from "./SelectPrincipal.vue?vue&type=template&id=461e6ac6&scoped=true&"
import script from "./SelectPrincipal.vue?vue&type=script&lang=js&"
export * from "./SelectPrincipal.vue?vue&type=script&lang=js&"
import style0 from "./SelectPrincipal.vue?vue&type=style&index=0&id=461e6ac6&prod&lang=scss&scoped=true&"
import style1 from "./SelectPrincipal.vue?vue&type=style&index=1&id=461e6ac6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461e6ac6",
  null
  
)

export default component.exports